// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presence-report-dialog__paper {
  --prd-gold: #c9a227;
  --prd-silver: #8e9aab;
  --prd-bronze: #c4844a;
  --prd-line: color-mix(in srgb, var(--text-color, #f9fafb) 10%, transparent);
  background: var(--surface-color, #111827) !important;
  color: var(--text-color, #f9fafb) !important;
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));
  border-radius: 18px !important;
  max-height: min(92vh, 880px);
}

.presence-report-dialog__paper .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.presence-report-dialog__title {
  padding-bottom: 8px !important;
}

.presence-report-dialog__subtitle {
  color: var(--text-secondary, #9ca3af) !important;
  margin-top: 4px !important;
}

.presence-report-dialog__range-label {
  display: block;
  margin-top: 8px;
  color: var(--text-secondary, #9ca3af);
}

.presence-report-dialog__content {
  padding-top: 8px !important;
}

.presence-report-dialog__presets {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.presence-report-dialog__preset-chip {
  border-color: var(--border-color, rgba(255, 255, 255, 0.16)) !important;
  color: var(--text-color, #f9fafb) !important;
  background: transparent !important;
}

.presence-report-dialog__preset-chip.MuiChip-outlined {
  background: transparent !important;
  color: var(--text-color, #f9fafb) !important;
  border-color: var(--border-color, rgba(255, 255, 255, 0.22)) !important;
}

.presence-report-dialog__preset-chip.MuiChip-filled,
.presence-report-dialog__preset-chip.MuiChip-colorPrimary.MuiChip-filled,
.presence-report-dialog__preset-chip--selected {
  background: var(--brand-primary, #0877bc) !important;
  color: #ffffff !important;
  border-color: var(--brand-primary, #0877bc) !important;
}

.presence-report-dialog__preset-chip .MuiChip-label {
  color: inherit !important;
}

.presence-report-dialog__calendar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  overflow-x: auto;
  max-width: 100%;
}

.presence-report-dialog__calendar .rdrCalendarWrapper,
.presence-report-dialog__calendar .rdrDateRangePickerWrapper {
  background: var(--bg-color, #0b0f19);
  color: var(--text-color, #f9fafb);
}

.presence-report-dialog__calendar .rdrMonthAndYearWrapper,
.presence-report-dialog__calendar .rdrMonths,
.presence-report-dialog__calendar .rdrMonth {
  background: transparent;
}

.presence-report-dialog__calendar .rdrMonthAndYearPickers select,
.presence-report-dialog__calendar .rdrNextPrevButton {
  color: var(--text-color, #f9fafb);
  background-color: rgba(255, 255, 255, 0.06);
}

.presence-report-dialog__calendar .rdrNextPrevButton i {
  border-color: var(--text-color, #f9fafb);
}

.presence-report-dialog__calendar .rdrDayNumber span,
.presence-report-dialog__calendar .rdrMonthName,
.presence-report-dialog__calendar .rdrWeekDay {
  color: var(--text-color, #f9fafb) !important;
  font-weight: 600;
}

.presence-report-dialog__calendar .rdrDayPassive .rdrDayNumber span {
  color: var(--text-secondary, #9ca3af) !important;
  opacity: 0.45;
  font-weight: 500;
}

.presence-report-dialog__calendar .rdrDayDisabled .rdrDayNumber span {
  color: var(--text-secondary, #9ca3af) !important;
  opacity: 0.4;
}

.presence-report-dialog__calendar .rdrDayToday .rdrDayNumber span:after {
  background: var(--brand-primary, #0877bc) !important;
}

/*
 * react-date-range paints selection with \`background: currentColor\` on
 * .rdrInRange / .rdrStartEdge / .rdrEndEdge. Never force those to white —
 * that washes out the brand fill and hides day numbers in light mode.
 * Only the day-number text should be white on top of the brand range.
 */
.presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
.presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
.presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
.presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
  color: #ffffff !important;
  font-weight: 700;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
}

.presence-report-dialog__calendar .rdrDayStartPreview,
.presence-report-dialog__calendar .rdrDayInPreview,
.presence-report-dialog__calendar .rdrDayEndPreview {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18) !important;
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45) !important;
}

.presence-report-dialog__calendar .rdrDefinedRangesWrapper {
  background: var(--surface-color, #111827);
  border-color: var(--border-color, rgba(255, 255, 255, 0.08));
}

.presence-report-dialog__calendar .rdrStaticRange {
  background: transparent;
  border-bottom-color: var(--border-color, rgba(255, 255, 255, 0.08));
  color: var(--text-color, #f9fafb);
}

.presence-report-dialog__calendar .rdrStaticRangeLabel {
  color: var(--text-color, #f9fafb);
}

.presence-report-dialog__calendar .rdrStaticRange:hover .rdrStaticRangeLabel,
.presence-report-dialog__calendar .rdrStaticRange:focus .rdrStaticRangeLabel {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
}

.presence-report-dialog__calendar .rdrInputRangeInput {
  background: var(--bg-color, #0b0f19);
  color: var(--text-color, #f9fafb);
  border-color: var(--border-color, rgba(255, 255, 255, 0.16));
}

.presence-report-dialog__apply {
  align-self: flex-start;
}

.presence-report-dialog__state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 160px;
  color: var(--text-secondary, #9ca3af);
  text-align: center;
}

.presence-report-dialog__state--error {
  color: #ef4444;
}

.presence-report-dialog__board {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.presence-report-dialog__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.presence-report-dialog__chart {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0 0 16px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid var(--prd-line);
  background: color-mix(in srgb, var(--bg-color, #0b0f19) 70%, transparent);
}

.presence-report-dialog__chart-row {
  display: grid;
  grid-template-columns: minmax(72px, 1fr) minmax(80px, 3fr) 48px;
  align-items: center;
  gap: 8px;
}

.presence-report-dialog__chart-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.78rem;
  font-weight: 650;
}

.presence-report-dialog__chart-track {
  height: 8px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--text-color, #f9fafb) 10%, transparent);
  overflow: hidden;
}

.presence-report-dialog__chart-fill {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: var(--brand-primary, #0877bc);
}

.presence-report-dialog__chart-val {
  font-variant-numeric: tabular-nums;
  font-size: 0.72rem;
  color: var(--text-secondary, #9ca3af);
  text-align: right;
}

.presence-report-dialog__summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.presence-report-dialog__summary li {
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--bg-color, #0b0f19) 72%, transparent);
  border: 1px solid var(--prd-line);
}

.presence-report-dialog__summary strong {
  font-variant-numeric: tabular-nums;
  font-size: 0.95rem;
  letter-spacing: -0.02em;
}

.presence-report-dialog__summary span {
  color: var(--text-secondary, #9ca3af);
  font-size: 0.72rem;
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.presence-report-dialog__search {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: min(100%, 240px);
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid var(--prd-line);
  background: color-mix(in srgb, var(--bg-color, #0b0f19) 80%, transparent);
  color: var(--text-secondary, #9ca3af);
}

.presence-report-dialog__search input {
  flex: 1 1;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text-color, #f9fafb);
  font-size: 0.9rem;
}

.presence-report-dialog__search:focus-within {
  border-color: var(--brand-primary, #0877bc);
  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);
}

.presence-report-dialog__table-wrap {
  overflow: auto;
  max-height: min(52vh, 520px);
  border: 1px solid var(--prd-line);
  border-radius: 16px;
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--brand-primary, #0877bc) 7%, transparent), transparent 42px),
    var(--bg-color, #0b0f19);
}

.presence-report-dialog__table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.9rem;
}

.presence-report-dialog__table th,
.presence-report-dialog__table td {
  padding: 12px 14px;
  text-align: left;
  color: var(--text-color, #f9fafb);
  vertical-align: middle;
}

.presence-report-dialog__table th {
  position: sticky;
  top: 0;
  z-index: 1;
  color: var(--text-secondary, #9ca3af);
  font-weight: 700;
  font-size: 0.7rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: color-mix(in srgb, var(--bg-color, #0b0f19) 92%, #000);
  white-space: nowrap;
  border-bottom: 1px solid var(--prd-line);
}

.presence-report-dialog__sort {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
}

.presence-report-dialog__sort:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 3px;
  border-radius: 4px;
}

.presence-report-dialog__sort.is-active {
  color: var(--text-color, #f9fafb);
}

.presence-report-dialog__caret {
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid currentColor;
  opacity: 0.35;
}

.presence-report-dialog__caret.is-asc {
  transform: rotate(180deg);
  opacity: 1;
}

.presence-report-dialog__caret.is-desc {
  opacity: 1;
}

.presence-report-dialog__table tbody tr td {
  border-bottom: 1px solid var(--prd-line);
}

.presence-report-dialog__table tbody tr:last-child td {
  border-bottom: none;
}

.presence-report-dialog__table tbody tr:hover td {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, transparent);
}

.presence-report-dialog__table tbody tr.is-podium-1 td:first-child {
  box-shadow: inset 3px 0 0 var(--prd-gold);
}

.presence-report-dialog__table tbody tr.is-podium-2 td:first-child {
  box-shadow: inset 3px 0 0 var(--prd-silver);
}

.presence-report-dialog__table tbody tr.is-podium-3 td:first-child {
  box-shadow: inset 3px 0 0 var(--prd-bronze);
}

.presence-report-dialog__rank {
  width: 56px;
}

.presence-report-dialog__lane {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 9px;
  font-variant-numeric: tabular-nums;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  background: color-mix(in srgb, var(--text-color, #fff) 8%, transparent);
  color: var(--text-secondary, #9ca3af);
}

.presence-report-dialog__lane--gold {
  background: color-mix(in srgb, var(--prd-gold) 22%, transparent);
  color: var(--prd-gold);
}

.presence-report-dialog__lane--silver {
  background: color-mix(in srgb, var(--prd-silver) 22%, transparent);
  color: var(--prd-silver);
}

.presence-report-dialog__lane--bronze {
  background: color-mix(in srgb, var(--prd-bronze) 22%, transparent);
  color: var(--prd-bronze);
}

.presence-report-dialog__who {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.presence-report-dialog__mark {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 11px;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: #f8fafc;
}

.presence-report-dialog__mark--pine { background: #2f6b57; }
.presence-report-dialog__mark--ink { background: #355a78; }
.presence-report-dialog__mark--clay { background: #8a5a3c; }
.presence-report-dialog__mark--slate { background: #4b5568; }
.presence-report-dialog__mark--lagoon { background: #2a6f7a; }

.presence-report-dialog__name {
  font-weight: 650;
  letter-spacing: -0.01em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.presence-report-dialog__stat {
  display: inline-flex;
  min-width: 2.2ch;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.presence-report-dialog__hours {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 140px;
  padding-right: 16px;
}

.presence-report-dialog__hours-val {
  order: -1;
  flex-shrink: 0;
  min-width: 4.6ch;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  letter-spacing: -0.03em;
  text-align: left;
}

.presence-report-dialog__meter {
  flex: 1 1 88px;
  height: 8px;
  min-width: 64px;
  max-width: 140px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--text-color, #fff) 10%, transparent);
  overflow: hidden;
}

.presence-report-dialog__meter-fill {
  display: block;
  height: 100%;
  width: var(--meter, 0%);
  border-radius: inherit;
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--brand-primary, #0877bc) 70%, #1b3d32),
    var(--brand-primary, #0877bc)
  );
}

.presence-report-dialog__hours-val small {
  margin-left: 2px;
  font-size: 0.68rem;
  font-weight: 700;
  color: var(--text-secondary, #9ca3af);
}

.presence-report-dialog__table--skeleton td {
  padding: 10px 14px;
}

.presence-report-dialog__skel {
  display: block;
  height: 36px;
  border-radius: 12px;
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--text-color, #fff) 6%, transparent) 0%,
    color-mix(in srgb, var(--text-color, #fff) 12%, transparent) 50%,
    color-mix(in srgb, var(--text-color, #fff) 6%, transparent) 100%
  );
  background-size: 180% 100%;
}

.presence-report-dialog__skel-caption {
  margin: 0;
  text-align: center;
  color: var(--text-secondary, #9ca3af);
  font-size: 0.82rem;
}

@media (prefers-reduced-motion: no-preference) {
  .presence-report-dialog__skel {
    animation: presence-skel 1.4s ease-in-out infinite;
  }
}

@keyframes presence-skel {
  0% { background-position: 100% 0; }
  100% { background-position: -80% 0; }
}

@media (max-width: 720px) {
  .presence-report-dialog .MuiDialog-container {
    width: 100%;
    max-width: 100vw;
  }

  .presence-report-dialog .MuiDialog-paper,
  .presence-report-dialog__paper {
    margin: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    height: 100% !important;
    max-height: 100% !important;
    border-radius: 0 !important;
  }

  .presence-report-dialog__calendar {
    align-items: stretch;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .presence-report-dialog__calendar .rdrCalendarWrapper,
  .presence-report-dialog__calendar .rdrDateRangePickerWrapper,
  .presence-report-dialog__calendar .rdrMonth {
    max-width: 100%;
  }

  .presence-report-dialog__table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
  }

  .presence-report-dialog__table,
  .presence-report-dialog__table tbody {
    display: block;
  }

  .presence-report-dialog__table tbody tr {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-areas:
      "lane who"
      "hours hours"
      "sessions exercises";
    gap: 8px 10px;
    margin: 8px;
    padding: 12px;
    border: 1px solid var(--prd-line);
    border-radius: 14px;
    background: color-mix(in srgb, var(--surface-color, #111827) 88%, transparent);
  }

  .presence-report-dialog__table tbody tr td {
    border: 0;
    padding: 0;
    background: transparent !important;
  }

  .presence-report-dialog__table tbody tr td:nth-child(1) { grid-area: lane; }
  .presence-report-dialog__table tbody tr td:nth-child(2) { grid-area: who; }
  .presence-report-dialog__table tbody tr td:nth-child(3) { grid-area: sessions; }
  .presence-report-dialog__table tbody tr td:nth-child(4) { grid-area: exercises; }
  .presence-report-dialog__table tbody tr td:nth-child(5) { grid-area: hours; }

  .presence-report-dialog__table tbody tr td[data-label]::before {
    display: block;
    margin-bottom: 4px;
    content: attr(data-label);
    color: var(--text-secondary, #9ca3af);
    font-size: 0.64rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .presence-report-dialog__table tbody tr td:nth-child(1)::before,
  .presence-report-dialog__table tbody tr td:nth-child(2)::before {
    display: none;
  }

  .presence-report-dialog__hours {
    min-width: 0;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-areas:
      "label label"
      "val meter";
    align-items: center;
    gap: 6px 10px;
  }

  .presence-report-dialog__hours::before {
    grid-area: label;
  }

  .presence-report-dialog__hours-val {
    order: 0;
    grid-area: val;
  }

  .presence-report-dialog__meter {
    grid-area: meter;
    max-width: none;
    min-width: 0;
  }
}

.light-mode .presence-report-dialog__paper {
  background: var(--surface-color, #ffffff) !important;
  color: var(--text-color, #1e1e1e) !important;
}

.light-mode .presence-report-dialog__preset-chip.MuiChip-outlined {
  color: var(--text-color, #1e1e1e) !important;
  border-color: rgba(0, 0, 0, 0.18) !important;
  background: var(--bg-color, #f4f5f6) !important;
}

.light-mode .presence-report-dialog__preset-chip.MuiChip-filled,
.light-mode .presence-report-dialog__preset-chip.MuiChip-colorPrimary.MuiChip-filled {
  background: var(--brand-primary, #0877bc) !important;
  color: #ffffff !important;
  border-color: var(--brand-primary, #0877bc) !important;
}

.light-mode .presence-report-dialog__table th {
  background: color-mix(in srgb, var(--bg-color, #f4f5f6) 94%, #fff);
}

.light-mode .presence-report-dialog__search input {
  color: var(--text-color, #1e1e1e);
}

.light-mode .presence-report-dialog__table-wrap {
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--brand-primary, #0877bc) 8%, #fff), var(--bg-color, #f4f5f6) 48px);
}

.light-mode .presence-report-dialog__calendar .rdrCalendarWrapper,
.light-mode .presence-report-dialog__calendar .rdrDateRangePickerWrapper {
  background: var(--surface-color, #ffffff);
  color: var(--text-color, #1e1e1e);
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
}

.light-mode .presence-report-dialog__calendar .rdrMonthAndYearPickers select,
.light-mode .presence-report-dialog__calendar .rdrNextPrevButton {
  color: var(--text-color, #1e1e1e);
  background-color: rgba(0, 0, 0, 0.04);
}

.light-mode .presence-report-dialog__calendar .rdrNextPrevButton i {
  border-color: var(--text-color, #1e1e1e);
}

.light-mode .presence-report-dialog__calendar .rdrMonthName,
.light-mode .presence-report-dialog__calendar .rdrWeekDay {
  color: var(--text-secondary, #5f6368) !important;
  font-weight: 700;
}

/* Default day numbers — dark on light surface */
.light-mode .presence-report-dialog__calendar .rdrDayNumber span {
  color: var(--text-color, #1a1a1a) !important;
  font-weight: 600;
}

.light-mode .presence-report-dialog__calendar .rdrDayPassive .rdrDayNumber span {
  color: #9aa0a6 !important;
  opacity: 1;
  font-weight: 500;
}

.light-mode .presence-report-dialog__calendar .rdrDayDisabled .rdrDayNumber span {
  color: #b0b5ba !important;
  opacity: 1;
}

/* Selected range stays brand-filled; keep day numbers white & bold */
.light-mode .presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
.light-mode .presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
.light-mode .presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
.light-mode .presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
  color: #ffffff !important;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
}

.light-mode .presence-report-dialog__calendar .rdrDayStartPreview,
.light-mode .presence-report-dialog__calendar .rdrDayInPreview,
.light-mode .presence-report-dialog__calendar .rdrDayEndPreview {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14) !important;
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4) !important;
}

.light-mode .presence-report-dialog__calendar .rdrDefinedRangesWrapper {
  background: var(--bg-color, #f4f5f6);
  border-color: rgba(0, 0, 0, 0.08);
}

.light-mode .presence-report-dialog__calendar .rdrStaticRange {
  border-bottom-color: rgba(0, 0, 0, 0.08);
}

.light-mode .presence-report-dialog__calendar .rdrStaticRangeLabel {
  color: var(--text-color, #1e1e1e);
}

.light-mode .presence-report-dialog__calendar .rdrStaticRange:hover .rdrStaticRangeLabel,
.light-mode .presence-report-dialog__calendar .rdrStaticRange:focus .rdrStaticRangeLabel {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1);
}

.light-mode .presence-report-dialog__calendar .rdrInputRangeInput {
  background: #ffffff;
  color: var(--text-color, #1e1e1e);
  border-color: rgba(0, 0, 0, 0.16);
}

.light-mode .presence-report-dialog__calendar .rdrDateDisplayItem,
.light-mode .presence-report-dialog__calendar .rdrDateDisplayItem input {
  background: #ffffff;
  color: var(--text-color, #1e1e1e);
  border-color: rgba(0, 0, 0, 0.12);
}

.light-mode .presence-report-dialog__calendar .rdrDateDisplayItemActive {
  border-color: var(--brand-primary, #0877bc);
}

.dark-mode .presence-report-dialog__preset-chip.MuiChip-outlined {
  color: var(--text-color, #f9fafb) !important;
  border-color: rgba(255, 255, 255, 0.22) !important;
  background: rgba(255, 255, 255, 0.04) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/PresenceReportDialog.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,2EAA2E;EAC3E,oDAAoD;EACpD,4CAA4C;EAC5C,gEAAgE;EAChE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gDAAgD;EAChD,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uEAAuE;EACvE,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,uEAAuE;AACzE;;AAEA;;;EAGE,oDAAoD;EACpD,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;EAEE,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;;EAGE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;;;;EAKE;AACF;;;;EAIE,yBAAyB;EACzB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;;EAGE,wEAAwE;EACxE,0EAA0E;AAC5E;;AAEA;EACE,yCAAyC;EACzC,4DAA4D;AAC9D;;AAEA;EACE,uBAAuB;EACvB,mEAAmE;EACnE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,6DAA6D;AAC/D;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,4DAA4D;AAC9D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,+DAA+D;EAC/D,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,2EAA2E;EAC3E,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,yEAAyE;EACzE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;EACjC,yEAAyE;EACzE,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,uEAAuE;AACzE;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,iCAAiC;EACjC,mBAAmB;EACnB;;4BAE0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kEAAkE;EAClE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,uEAAuE;EACvE,qCAAqC;AACvC;;AAEA;EACE,gEAAgE;EAChE,sBAAsB;AACxB;;AAEA;EACE,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,sCAAsC,mBAAmB,EAAE;AAC3D,qCAAqC,mBAAmB,EAAE;AAC1D,sCAAsC,mBAAmB,EAAE;AAC3D,uCAAuC,mBAAmB,EAAE;AAC5D,wCAAwC,mBAAmB,EAAE;;AAE7D;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,wEAAwE;EACxE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB;;;;GAIC;AACH;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE;IACE,kDAAkD;EACpD;AACF;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,+BAA+B;IAC/B;;;0BAGsB;IACtB,aAAa;IACb,WAAW;IACX,aAAa;IACb,iCAAiC;IACjC,mBAAmB;IACnB,8EAA8E;EAChF;;EAEA;IACE,SAAS;IACT,UAAU;IACV,kCAAkC;EACpC;;EAEA,0DAA0D,eAAe,EAAE;EAC3E,0DAA0D,cAAc,EAAE;EAC1E,0DAA0D,mBAAmB,EAAE;EAC/E,0DAA0D,oBAAoB,EAAE;EAChF,0DAA0D,gBAAgB,EAAE;;EAE5E;IACE,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B;;iBAEa;IACb,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,oDAAoD;EACpD,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;;EAEE,oDAAoD;EACpD,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;sHACoH;AACtH;;AAEA;;EAEE,yCAAyC;EACzC,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA,qEAAqE;AACrE;;;;EAIE,yBAAyB;EACzB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;;EAGE,wEAAwE;EACxE,yEAAyE;AAC3E;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;EACnB,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;EAC5C,kDAAkD;EAClD,gDAAgD;AAClD","sourcesContent":[".presence-report-dialog__paper {\n  --prd-gold: #c9a227;\n  --prd-silver: #8e9aab;\n  --prd-bronze: #c4844a;\n  --prd-line: color-mix(in srgb, var(--text-color, #f9fafb) 10%, transparent);\n  background: var(--surface-color, #111827) !important;\n  color: var(--text-color, #f9fafb) !important;\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));\n  border-radius: 18px !important;\n  max-height: min(92vh, 880px);\n}\n\n.presence-report-dialog__paper .sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.presence-report-dialog__title {\n  padding-bottom: 8px !important;\n}\n\n.presence-report-dialog__subtitle {\n  color: var(--text-secondary, #9ca3af) !important;\n  margin-top: 4px !important;\n}\n\n.presence-report-dialog__range-label {\n  display: block;\n  margin-top: 8px;\n  color: var(--text-secondary, #9ca3af);\n}\n\n.presence-report-dialog__content {\n  padding-top: 8px !important;\n}\n\n.presence-report-dialog__presets {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.presence-report-dialog__preset-chip {\n  border-color: var(--border-color, rgba(255, 255, 255, 0.16)) !important;\n  color: var(--text-color, #f9fafb) !important;\n  background: transparent !important;\n}\n\n.presence-report-dialog__preset-chip.MuiChip-outlined {\n  background: transparent !important;\n  color: var(--text-color, #f9fafb) !important;\n  border-color: var(--border-color, rgba(255, 255, 255, 0.22)) !important;\n}\n\n.presence-report-dialog__preset-chip.MuiChip-filled,\n.presence-report-dialog__preset-chip.MuiChip-colorPrimary.MuiChip-filled,\n.presence-report-dialog__preset-chip--selected {\n  background: var(--brand-primary, #0877bc) !important;\n  color: #ffffff !important;\n  border-color: var(--brand-primary, #0877bc) !important;\n}\n\n.presence-report-dialog__preset-chip .MuiChip-label {\n  color: inherit !important;\n}\n\n.presence-report-dialog__calendar {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 16px;\n  overflow-x: auto;\n  max-width: 100%;\n}\n\n.presence-report-dialog__calendar .rdrCalendarWrapper,\n.presence-report-dialog__calendar .rdrDateRangePickerWrapper {\n  background: var(--bg-color, #0b0f19);\n  color: var(--text-color, #f9fafb);\n}\n\n.presence-report-dialog__calendar .rdrMonthAndYearWrapper,\n.presence-report-dialog__calendar .rdrMonths,\n.presence-report-dialog__calendar .rdrMonth {\n  background: transparent;\n}\n\n.presence-report-dialog__calendar .rdrMonthAndYearPickers select,\n.presence-report-dialog__calendar .rdrNextPrevButton {\n  color: var(--text-color, #f9fafb);\n  background-color: rgba(255, 255, 255, 0.06);\n}\n\n.presence-report-dialog__calendar .rdrNextPrevButton i {\n  border-color: var(--text-color, #f9fafb);\n}\n\n.presence-report-dialog__calendar .rdrDayNumber span,\n.presence-report-dialog__calendar .rdrMonthName,\n.presence-report-dialog__calendar .rdrWeekDay {\n  color: var(--text-color, #f9fafb) !important;\n  font-weight: 600;\n}\n\n.presence-report-dialog__calendar .rdrDayPassive .rdrDayNumber span {\n  color: var(--text-secondary, #9ca3af) !important;\n  opacity: 0.45;\n  font-weight: 500;\n}\n\n.presence-report-dialog__calendar .rdrDayDisabled .rdrDayNumber span {\n  color: var(--text-secondary, #9ca3af) !important;\n  opacity: 0.4;\n}\n\n.presence-report-dialog__calendar .rdrDayToday .rdrDayNumber span:after {\n  background: var(--brand-primary, #0877bc) !important;\n}\n\n/*\n * react-date-range paints selection with `background: currentColor` on\n * .rdrInRange / .rdrStartEdge / .rdrEndEdge. Never force those to white —\n * that washes out the brand fill and hides day numbers in light mode.\n * Only the day-number text should be white on top of the brand range.\n */\n.presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,\n.presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,\n.presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,\n.presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {\n  color: #ffffff !important;\n  font-weight: 700;\n  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);\n}\n\n.presence-report-dialog__calendar .rdrDayStartPreview,\n.presence-report-dialog__calendar .rdrDayInPreview,\n.presence-report-dialog__calendar .rdrDayEndPreview {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18) !important;\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.45) !important;\n}\n\n.presence-report-dialog__calendar .rdrDefinedRangesWrapper {\n  background: var(--surface-color, #111827);\n  border-color: var(--border-color, rgba(255, 255, 255, 0.08));\n}\n\n.presence-report-dialog__calendar .rdrStaticRange {\n  background: transparent;\n  border-bottom-color: var(--border-color, rgba(255, 255, 255, 0.08));\n  color: var(--text-color, #f9fafb);\n}\n\n.presence-report-dialog__calendar .rdrStaticRangeLabel {\n  color: var(--text-color, #f9fafb);\n}\n\n.presence-report-dialog__calendar .rdrStaticRange:hover .rdrStaticRangeLabel,\n.presence-report-dialog__calendar .rdrStaticRange:focus .rdrStaticRangeLabel {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n}\n\n.presence-report-dialog__calendar .rdrInputRangeInput {\n  background: var(--bg-color, #0b0f19);\n  color: var(--text-color, #f9fafb);\n  border-color: var(--border-color, rgba(255, 255, 255, 0.16));\n}\n\n.presence-report-dialog__apply {\n  align-self: flex-start;\n}\n\n.presence-report-dialog__state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  min-height: 160px;\n  color: var(--text-secondary, #9ca3af);\n  text-align: center;\n}\n\n.presence-report-dialog__state--error {\n  color: #ef4444;\n}\n\n.presence-report-dialog__board {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.presence-report-dialog__toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.presence-report-dialog__chart {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 0 0 16px;\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid var(--prd-line);\n  background: color-mix(in srgb, var(--bg-color, #0b0f19) 70%, transparent);\n}\n\n.presence-report-dialog__chart-row {\n  display: grid;\n  grid-template-columns: minmax(72px, 1fr) minmax(80px, 3fr) 48px;\n  align-items: center;\n  gap: 8px;\n}\n\n.presence-report-dialog__chart-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.78rem;\n  font-weight: 650;\n}\n\n.presence-report-dialog__chart-track {\n  height: 8px;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--text-color, #f9fafb) 10%, transparent);\n  overflow: hidden;\n}\n\n.presence-report-dialog__chart-fill {\n  display: block;\n  height: 100%;\n  border-radius: 999px;\n  background: var(--brand-primary, #0877bc);\n}\n\n.presence-report-dialog__chart-val {\n  font-variant-numeric: tabular-nums;\n  font-size: 0.72rem;\n  color: var(--text-secondary, #9ca3af);\n  text-align: right;\n}\n\n.presence-report-dialog__summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.presence-report-dialog__summary li {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--bg-color, #0b0f19) 72%, transparent);\n  border: 1px solid var(--prd-line);\n}\n\n.presence-report-dialog__summary strong {\n  font-variant-numeric: tabular-nums;\n  font-size: 0.95rem;\n  letter-spacing: -0.02em;\n}\n\n.presence-report-dialog__summary span {\n  color: var(--text-secondary, #9ca3af);\n  font-size: 0.72rem;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.presence-report-dialog__search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: min(100%, 240px);\n  padding: 8px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--prd-line);\n  background: color-mix(in srgb, var(--bg-color, #0b0f19) 80%, transparent);\n  color: var(--text-secondary, #9ca3af);\n}\n\n.presence-report-dialog__search input {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-color, #f9fafb);\n  font-size: 0.9rem;\n}\n\n.presence-report-dialog__search:focus-within {\n  border-color: var(--brand-primary, #0877bc);\n  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18);\n}\n\n.presence-report-dialog__table-wrap {\n  overflow: auto;\n  max-height: min(52vh, 520px);\n  border: 1px solid var(--prd-line);\n  border-radius: 16px;\n  background:\n    linear-gradient(180deg, color-mix(in srgb, var(--brand-primary, #0877bc) 7%, transparent), transparent 42px),\n    var(--bg-color, #0b0f19);\n}\n\n.presence-report-dialog__table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 0.9rem;\n}\n\n.presence-report-dialog__table th,\n.presence-report-dialog__table td {\n  padding: 12px 14px;\n  text-align: left;\n  color: var(--text-color, #f9fafb);\n  vertical-align: middle;\n}\n\n.presence-report-dialog__table th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  color: var(--text-secondary, #9ca3af);\n  font-weight: 700;\n  font-size: 0.7rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  background: color-mix(in srgb, var(--bg-color, #0b0f19) 92%, #000);\n  white-space: nowrap;\n  border-bottom: 1px solid var(--prd-line);\n}\n\n.presence-report-dialog__sort {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n  cursor: pointer;\n}\n\n.presence-report-dialog__sort:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 3px;\n  border-radius: 4px;\n}\n\n.presence-report-dialog__sort.is-active {\n  color: var(--text-color, #f9fafb);\n}\n\n.presence-report-dialog__caret {\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 5px solid currentColor;\n  opacity: 0.35;\n}\n\n.presence-report-dialog__caret.is-asc {\n  transform: rotate(180deg);\n  opacity: 1;\n}\n\n.presence-report-dialog__caret.is-desc {\n  opacity: 1;\n}\n\n.presence-report-dialog__table tbody tr td {\n  border-bottom: 1px solid var(--prd-line);\n}\n\n.presence-report-dialog__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.presence-report-dialog__table tbody tr:hover td {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, transparent);\n}\n\n.presence-report-dialog__table tbody tr.is-podium-1 td:first-child {\n  box-shadow: inset 3px 0 0 var(--prd-gold);\n}\n\n.presence-report-dialog__table tbody tr.is-podium-2 td:first-child {\n  box-shadow: inset 3px 0 0 var(--prd-silver);\n}\n\n.presence-report-dialog__table tbody tr.is-podium-3 td:first-child {\n  box-shadow: inset 3px 0 0 var(--prd-bronze);\n}\n\n.presence-report-dialog__rank {\n  width: 56px;\n}\n\n.presence-report-dialog__lane {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 9px;\n  font-variant-numeric: tabular-nums;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  background: color-mix(in srgb, var(--text-color, #fff) 8%, transparent);\n  color: var(--text-secondary, #9ca3af);\n}\n\n.presence-report-dialog__lane--gold {\n  background: color-mix(in srgb, var(--prd-gold) 22%, transparent);\n  color: var(--prd-gold);\n}\n\n.presence-report-dialog__lane--silver {\n  background: color-mix(in srgb, var(--prd-silver) 22%, transparent);\n  color: var(--prd-silver);\n}\n\n.presence-report-dialog__lane--bronze {\n  background: color-mix(in srgb, var(--prd-bronze) 22%, transparent);\n  color: var(--prd-bronze);\n}\n\n.presence-report-dialog__who {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.presence-report-dialog__mark {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 11px;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  color: #f8fafc;\n}\n\n.presence-report-dialog__mark--pine { background: #2f6b57; }\n.presence-report-dialog__mark--ink { background: #355a78; }\n.presence-report-dialog__mark--clay { background: #8a5a3c; }\n.presence-report-dialog__mark--slate { background: #4b5568; }\n.presence-report-dialog__mark--lagoon { background: #2a6f7a; }\n\n.presence-report-dialog__name {\n  font-weight: 650;\n  letter-spacing: -0.01em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.presence-report-dialog__stat {\n  display: inline-flex;\n  min-width: 2.2ch;\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.presence-report-dialog__hours {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 140px;\n  padding-right: 16px;\n}\n\n.presence-report-dialog__hours-val {\n  order: -1;\n  flex-shrink: 0;\n  min-width: 4.6ch;\n  font-variant-numeric: tabular-nums;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  text-align: left;\n}\n\n.presence-report-dialog__meter {\n  flex: 1 1 88px;\n  height: 8px;\n  min-width: 64px;\n  max-width: 140px;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--text-color, #fff) 10%, transparent);\n  overflow: hidden;\n}\n\n.presence-report-dialog__meter-fill {\n  display: block;\n  height: 100%;\n  width: var(--meter, 0%);\n  border-radius: inherit;\n  background: linear-gradient(\n    90deg,\n    color-mix(in srgb, var(--brand-primary, #0877bc) 70%, #1b3d32),\n    var(--brand-primary, #0877bc)\n  );\n}\n\n.presence-report-dialog__hours-val small {\n  margin-left: 2px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: var(--text-secondary, #9ca3af);\n}\n\n.presence-report-dialog__table--skeleton td {\n  padding: 10px 14px;\n}\n\n.presence-report-dialog__skel {\n  display: block;\n  height: 36px;\n  border-radius: 12px;\n  background: linear-gradient(\n    90deg,\n    color-mix(in srgb, var(--text-color, #fff) 6%, transparent) 0%,\n    color-mix(in srgb, var(--text-color, #fff) 12%, transparent) 50%,\n    color-mix(in srgb, var(--text-color, #fff) 6%, transparent) 100%\n  );\n  background-size: 180% 100%;\n}\n\n.presence-report-dialog__skel-caption {\n  margin: 0;\n  text-align: center;\n  color: var(--text-secondary, #9ca3af);\n  font-size: 0.82rem;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .presence-report-dialog__skel {\n    animation: presence-skel 1.4s ease-in-out infinite;\n  }\n}\n\n@keyframes presence-skel {\n  0% { background-position: 100% 0; }\n  100% { background-position: -80% 0; }\n}\n\n@media (max-width: 720px) {\n  .presence-report-dialog .MuiDialog-container {\n    width: 100%;\n    max-width: 100vw;\n  }\n\n  .presence-report-dialog .MuiDialog-paper,\n  .presence-report-dialog__paper {\n    margin: 0 !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    height: 100% !important;\n    max-height: 100% !important;\n    border-radius: 0 !important;\n  }\n\n  .presence-report-dialog__calendar {\n    align-items: stretch;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .presence-report-dialog__calendar .rdrCalendarWrapper,\n  .presence-report-dialog__calendar .rdrDateRangePickerWrapper,\n  .presence-report-dialog__calendar .rdrMonth {\n    max-width: 100%;\n  }\n\n  .presence-report-dialog__table thead {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n  }\n\n  .presence-report-dialog__table,\n  .presence-report-dialog__table tbody {\n    display: block;\n  }\n\n  .presence-report-dialog__table tbody tr {\n    display: grid;\n    grid-template-columns: auto 1fr;\n    grid-template-areas:\n      \"lane who\"\n      \"hours hours\"\n      \"sessions exercises\";\n    gap: 8px 10px;\n    margin: 8px;\n    padding: 12px;\n    border: 1px solid var(--prd-line);\n    border-radius: 14px;\n    background: color-mix(in srgb, var(--surface-color, #111827) 88%, transparent);\n  }\n\n  .presence-report-dialog__table tbody tr td {\n    border: 0;\n    padding: 0;\n    background: transparent !important;\n  }\n\n  .presence-report-dialog__table tbody tr td:nth-child(1) { grid-area: lane; }\n  .presence-report-dialog__table tbody tr td:nth-child(2) { grid-area: who; }\n  .presence-report-dialog__table tbody tr td:nth-child(3) { grid-area: sessions; }\n  .presence-report-dialog__table tbody tr td:nth-child(4) { grid-area: exercises; }\n  .presence-report-dialog__table tbody tr td:nth-child(5) { grid-area: hours; }\n\n  .presence-report-dialog__table tbody tr td[data-label]::before {\n    display: block;\n    margin-bottom: 4px;\n    content: attr(data-label);\n    color: var(--text-secondary, #9ca3af);\n    font-size: 0.64rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n  }\n\n  .presence-report-dialog__table tbody tr td:nth-child(1)::before,\n  .presence-report-dialog__table tbody tr td:nth-child(2)::before {\n    display: none;\n  }\n\n  .presence-report-dialog__hours {\n    min-width: 0;\n    display: grid;\n    grid-template-columns: auto 1fr;\n    grid-template-areas:\n      \"label label\"\n      \"val meter\";\n    align-items: center;\n    gap: 6px 10px;\n  }\n\n  .presence-report-dialog__hours::before {\n    grid-area: label;\n  }\n\n  .presence-report-dialog__hours-val {\n    order: 0;\n    grid-area: val;\n  }\n\n  .presence-report-dialog__meter {\n    grid-area: meter;\n    max-width: none;\n    min-width: 0;\n  }\n}\n\n.light-mode .presence-report-dialog__paper {\n  background: var(--surface-color, #ffffff) !important;\n  color: var(--text-color, #1e1e1e) !important;\n}\n\n.light-mode .presence-report-dialog__preset-chip.MuiChip-outlined {\n  color: var(--text-color, #1e1e1e) !important;\n  border-color: rgba(0, 0, 0, 0.18) !important;\n  background: var(--bg-color, #f4f5f6) !important;\n}\n\n.light-mode .presence-report-dialog__preset-chip.MuiChip-filled,\n.light-mode .presence-report-dialog__preset-chip.MuiChip-colorPrimary.MuiChip-filled {\n  background: var(--brand-primary, #0877bc) !important;\n  color: #ffffff !important;\n  border-color: var(--brand-primary, #0877bc) !important;\n}\n\n.light-mode .presence-report-dialog__table th {\n  background: color-mix(in srgb, var(--bg-color, #f4f5f6) 94%, #fff);\n}\n\n.light-mode .presence-report-dialog__search input {\n  color: var(--text-color, #1e1e1e);\n}\n\n.light-mode .presence-report-dialog__table-wrap {\n  background:\n    linear-gradient(180deg, color-mix(in srgb, var(--brand-primary, #0877bc) 8%, #fff), var(--bg-color, #f4f5f6) 48px);\n}\n\n.light-mode .presence-report-dialog__calendar .rdrCalendarWrapper,\n.light-mode .presence-report-dialog__calendar .rdrDateRangePickerWrapper {\n  background: var(--surface-color, #ffffff);\n  color: var(--text-color, #1e1e1e);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  border-radius: 10px;\n}\n\n.light-mode .presence-report-dialog__calendar .rdrMonthAndYearPickers select,\n.light-mode .presence-report-dialog__calendar .rdrNextPrevButton {\n  color: var(--text-color, #1e1e1e);\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n.light-mode .presence-report-dialog__calendar .rdrNextPrevButton i {\n  border-color: var(--text-color, #1e1e1e);\n}\n\n.light-mode .presence-report-dialog__calendar .rdrMonthName,\n.light-mode .presence-report-dialog__calendar .rdrWeekDay {\n  color: var(--text-secondary, #5f6368) !important;\n  font-weight: 700;\n}\n\n/* Default day numbers — dark on light surface */\n.light-mode .presence-report-dialog__calendar .rdrDayNumber span {\n  color: var(--text-color, #1a1a1a) !important;\n  font-weight: 600;\n}\n\n.light-mode .presence-report-dialog__calendar .rdrDayPassive .rdrDayNumber span {\n  color: #9aa0a6 !important;\n  opacity: 1;\n  font-weight: 500;\n}\n\n.light-mode .presence-report-dialog__calendar .rdrDayDisabled .rdrDayNumber span {\n  color: #b0b5ba !important;\n  opacity: 1;\n}\n\n/* Selected range stays brand-filled; keep day numbers white & bold */\n.light-mode .presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,\n.light-mode .presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,\n.light-mode .presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,\n.light-mode .presence-report-dialog__calendar .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {\n  color: #ffffff !important;\n  font-weight: 700;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);\n}\n\n.light-mode .presence-report-dialog__calendar .rdrDayStartPreview,\n.light-mode .presence-report-dialog__calendar .rdrDayInPreview,\n.light-mode .presence-report-dialog__calendar .rdrDayEndPreview {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14) !important;\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4) !important;\n}\n\n.light-mode .presence-report-dialog__calendar .rdrDefinedRangesWrapper {\n  background: var(--bg-color, #f4f5f6);\n  border-color: rgba(0, 0, 0, 0.08);\n}\n\n.light-mode .presence-report-dialog__calendar .rdrStaticRange {\n  border-bottom-color: rgba(0, 0, 0, 0.08);\n}\n\n.light-mode .presence-report-dialog__calendar .rdrStaticRangeLabel {\n  color: var(--text-color, #1e1e1e);\n}\n\n.light-mode .presence-report-dialog__calendar .rdrStaticRange:hover .rdrStaticRangeLabel,\n.light-mode .presence-report-dialog__calendar .rdrStaticRange:focus .rdrStaticRangeLabel {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1);\n}\n\n.light-mode .presence-report-dialog__calendar .rdrInputRangeInput {\n  background: #ffffff;\n  color: var(--text-color, #1e1e1e);\n  border-color: rgba(0, 0, 0, 0.16);\n}\n\n.light-mode .presence-report-dialog__calendar .rdrDateDisplayItem,\n.light-mode .presence-report-dialog__calendar .rdrDateDisplayItem input {\n  background: #ffffff;\n  color: var(--text-color, #1e1e1e);\n  border-color: rgba(0, 0, 0, 0.12);\n}\n\n.light-mode .presence-report-dialog__calendar .rdrDateDisplayItemActive {\n  border-color: var(--brand-primary, #0877bc);\n}\n\n.dark-mode .presence-report-dialog__preset-chip.MuiChip-outlined {\n  color: var(--text-color, #f9fafb) !important;\n  border-color: rgba(255, 255, 255, 0.22) !important;\n  background: rgba(255, 255, 255, 0.04) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
